// Having a custom error type for errors within the ErrorReporter makes it
// easier to distinguish these between app errors when debugging. In the future
// We may want to filter these out when reporting uncaught errors and unhandled
// promise rejections.
export class ErrorReporterOriginatedError extends Error {
  readonly errorReporterOriginated = true;

  constructor(...params: any[]) {
    super(...params);
  }
}
